import { render, staticRenderFns } from "./SecretDocumentsCard.vue?vue&type=template&id=41594d84&"
import script from "./SecretDocumentsCard.vue?vue&type=script&lang=js&"
export * from "./SecretDocumentsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports